import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Table } from 'react-bootstrap';
import { CurrencyPlainText } from 'helpers/Currency';
import { api } from 'services';
import ReactTooltip from "react-tooltip";
import './style.css';
import { CurrencyDollarPlainText } from 'helpers/Currency';
import { CurrencyEuroPlainText } from 'helpers/Currency';

const PlanMarginResume = ({ planId, actions, currency }) => {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);
  const [margin, setMargin] = useState(0);
  const [expense, setExpense] = useState(0);
  const [marginExpected, setMarginExpected] = useState(0);
  const [expenseExpected, setExpenseExpected] = useState(0);
  const [expireValue, setExpireValue] = useState(0);
  const [load, setLoad] = useState(false);
  const [realValues, setRealValues] = useState(null);


  useEffect(() => {
    if(!load){
      setLoad(true);
      api.get(`marketing-plan-margin/${planId}`).then(({ data }) => {
        setTotal(data.value);
        setExpense(data.expense);
        setExpireValue(data.expire);
        setMargin(data.margin);
        setMarginExpected(data.marginExpected);
        setExpenseExpected(data.expenseExpected);
        if(data.isOtherCurrency){
          setRealValues({
            total: data.valueReal,
            expense: data.expenseReal,
            expireValue: data.expireReal,
            margin: data.marginReal,
            marginExpected: data.marginExpectedReal,
            expenseExpected: data.expenseExpectedReal,
          });
        }
      });
    }
  },[actions]);

  const getCurrency = (value, forceCurrency = null) => {
    switch (forceCurrency?forceCurrency:currency) {
      case '1':
        return <CurrencyPlainText value={value} />;
        break;
      case '2':
        return <CurrencyDollarPlainText value={value} />;
        break;
      case '3':
        return <CurrencyEuroPlainText value={value} />;
        break;
      default:
        break;
    }
  };

  const renderTooltip = (id, m) => {
    return <>
      <img src='/icons/percent-circle-outline.png' className={'icone-percentage'} alt={id} data-tip data-for={id}/>
      {/* <i className={'fa fa-percentage icone-percentage-2'} data-tip data-for={id}></i> */}
      
      <ReactTooltip id={id} place="top" effect="solid">
        {m}
      </ReactTooltip>
    </>;
  };

  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col>
              <label>{t('title:resume')}</label>
            </Col>
          </Row>
          <Table bordered responsive>
            <thead>
              <tr>
                <th className="text-center align-middle">
                  {t('label:total action value')}
                </th>

                <th className="text-center align-middle">{t('label:expected spent')}</th>
                <th className="text-center align-middle">{t('label:real spent')}</th>

                <th className="text-center align-middle">
                  {t('label:action expire value')}
                </th>

                <th className="text-center align-middle">
                  {t('label:expected margin')}<br/>
                  {renderTooltip('expected',((marginExpected*100) / total).toLocaleString('pt-BR',{maximumFractionDigits:2,minimumFractionDigits:0})+'%')}
                </th>

                <th className="text-center align-middle">
                  {t('label:real margin')}<br/>
                  {renderTooltip('real',((margin*100) / total).toLocaleString('pt-BR',{maximumFractionDigits:2,minimumFractionDigits:0})+'%')}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center align-middle">
                  {getCurrency(total)}
                </td>
                <td className="text-center align-middle">
                  {getCurrency(expenseExpected)}
                </td>
                <td className="text-center align-middle">
                  {getCurrency(expense)}
                </td>
                
                <td className="text-center align-middle">
                  {getCurrency(expireValue)}
                </td>
               
                <td className="text-center align-middle">
                  {getCurrency(marginExpected)}
                </td>

                <td className="text-center align-middle">
                  {getCurrency(margin)}
                </td>
              </tr>
              {realValues?(
                <tr>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.total,'1')}
                  </td>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.expenseExpected,'1')}
                  </td>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.expense,'1')}
                  </td>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.expireValue,'1')}
                  </td>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.marginExpected,'1')}
                  </td>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.margin,'1')}
                  </td>
                </tr>
              ):''}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

export default PlanMarginResume;
